"use client";

import { LocalizationProvider as MUILocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import "dayjs/locale/pt-br";

dayjs.extend(customParseFormat);

type LocalizationProviderProps = {
  children: React.ReactNode;
};

export default function LocalizationProvider({ children }: LocalizationProviderProps) {
  return (
    <MUILocalizationProvider adapterLocale="pt-br" dateAdapter={AdapterDayjs}>
      {children}
    </MUILocalizationProvider>
  );
}
